module.exports = __webpack_public_path__ + "img/vegetable-endive-350x184.2629c86c.jpg";